export const homePath = '/';
export const defaultRedirectPath = '/web';
export const webPagePath = '/web';
export const registrationPagePath = '/registration';
export const resetPasswordBase = '/user/reset-password';
export const resetPasswordPath = `${resetPasswordBase}/:id`;
export const sendEmailBase = 'send-reset-email';
export const sendResetPasswordEmailPath = `${resetPasswordBase}/${sendEmailBase}`;
